<template>
    <v-app :class="{ 'app-shell': !isStatsPage }">
        <v-container class="px-0 mx-0 py-0" fluid no-gutters>
            <v-row v-if="isLoggedIn && !isStatsPage" no-gutters class="px-0 mx-0">
                <v-col :cols="12" class="px-0 mx-0">
                    <topbar />
                </v-col>
            </v-row>
            <v-row no-gutters :class="isStatsPage ? 'py-0' : 'pt-14'" class="px-0 mx-0">
                <v-col v-if="isLoggedIn && !isStatsPage" cols="1">
                    <sidebar />
                </v-col>
                <v-col cols="12" class="px-0 mx-0">
                    <router-view :key="$route.path" />
                </v-col>
            </v-row>
        </v-container>
        <v-btn
            v-show="fab"
            v-scroll="onScroll"
            fab
            dark
            fixed
            bottom
            right
            color="black"
            @click="toTop"
        >
            <v-icon large>mdi-chevron-up</v-icon>
        </v-btn>
    </v-app>
</template>

<script>
    import Sidebar from '@/components/Sidebar'
    import Topbar from '@/components/Topbar'
    import jwtUtil from '@/utils/jwtUtil'

    export default {
        name: 'App',
        components: {
            Sidebar,
            Topbar
        },
        data: () => ({
            interval: null,
            fab: false
        }),
        computed: {
            isLoggedIn() {
                return this.$store.getters.isLoggedIn
            },
            drawer() {
                return this.$store.getters.getDrawer
            },
            isStatsPage() {
                return this.$route.name === 'Match Stat Page'
            },
            jwtToken() {
                return this.$store.getters.getToken
            }
        },
        watch: {
            $route() {
                document.title = `Commercial CMS - ${this.$route.name}`
            },
            // start watching the token on login (not only on page load) and stop on logout
            isLoggedIn: {
                handler(loggedIn) {
                    clearInterval(this.interval)
                    this.interval = loggedIn ? setInterval(this.checkJwt, 1000) : null
                },
                immediate: true
            }
        },
        beforeDestroy() {
            clearInterval(this.interval)
        },
        methods: {
            onScroll(e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset || e.target.scrollTop || 0
                this.fab = top > 20
            },
            toTop() {
                this.$vuetify.goTo(0)
            },
            checkJwt() {
                if (jwtUtil.isJwtExpired(this.jwtToken)) {
                    clearInterval(this.interval)
                    this.$store.dispatch('logout').then(() => {
                        if (this.$route.name !== 'Login') {
                            this.$router.push({ path: '/login' })
                        }
                    })
                }
            }
        }
    }
</script>

<style>
    /* light grey canvas so the white cards stand out (stats pages keep their own look) */
    .v-application.app-shell {
        background: #eef1f1 !important;
    }

    /* titles in the display font of the website */
    .squada {
        font-family: 'Squada One', Arial, sans-serif !important;
        letter-spacing: 0.03em;
    }

    /* shared form layout (see src/forms/*Form.vue) */
    .form-card {
        padding: 20px 24px;
    }

    .form-section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 24px 0 12px;
        padding-bottom: 6px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        font-size: 0.75rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: rgba(0, 0, 0, 0.6);
    }

    .form-section-title:first-child {
        margin-top: 0;
    }

    .form-section-title .v-icon {
        color: #009688 !important;
    }

    .form-section-title {
        border-bottom-color: rgba(0, 150, 136, 0.25) !important;
    }

    .form-actions {
        position: sticky;
        bottom: 0;
        z-index: 2;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        margin-top: 16px;
        padding: 12px 16px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    }

    .custom-container {
        padding-bottom: 20vh;
        padding-top: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }
</style>
